export interface ScoringConfig {
  /** Bottles (collectible value) needed for one extra life. Counter resets afterwards. */
  readonly bottlesPerExtraLife: number;
  readonly maxExtraLives: number;
  readonly startExtraLives: number;
  readonly pointsPerMeter: number;
  readonly pointsPerBottle: number;
}

export const SCORING_CONFIG: ScoringConfig = {
  bottlesPerExtraLife: 200, // user 2026-10-03: "erst ab zweihundert Flaschen ein neues Leben" (was 100)
  maxExtraLives: 3,
  startExtraLives: 0,
  pointsPerMeter: 1,
  pointsPerBottle: 10,
};
